import { simpleColumnType } from '@sisense/sdk-data';
import numeral from 'numeral';
export const getDataFromQueryResult = (result, metadata) => {
    const values = getQueryResultValues(result);
    return prepareResultAsColsAndRows(values, metadata);
};
export function prepareResultAsColsAndRows(data, metadata) {
    return {
        columns: metadata === null || metadata === void 0 ? void 0 : metadata.map((d) => ({
            name: d.name,
            type: simpleColumnType(d.type),
        })),
        rows: setCellsBlur(data),
    };
}
/**
 * Sets the `blur` property for each cell in a 2D array of data cells based on the `selected` property.
 *
 * @param rows - The 2D array of data cells representing rows and columns.
 * @returns A new 2D array of cells with the `blur` property set.
 */
export function setCellsBlur(rows) {
    var _a;
    // A boolean flag indicating whether highlight is enabled on some column.
    let isHighlightEnabledSomeColumn = false;
    // An array indicating whether highlight is enabled per each column.
    const highlightEnabledPerColumn = (_a = rows[0]) === null || _a === void 0 ? void 0 : _a.map((_value, index) => {
        const isHighlightEnabled = rows.some((r) => 'selected' in r[index]);
        if (isHighlightEnabled) {
            isHighlightEnabledSomeColumn = true;
        }
        return isHighlightEnabled;
    });
    return rows.map((r) => {
        // calculates a single `blur` value for a whole row based on each column (cell) configuration.
        // true: the data value is blurred
        // false: the data value is highlighted
        // undefined: the data value is neutral (neither highlighted nor blurred)
        const blur = !isHighlightEnabledSomeColumn
            ? undefined
            : highlightEnabledPerColumn.some((isHighlightEnabled, columnIndex) => isHighlightEnabled && !r[columnIndex].selected);
        return r.map((d) => blur !== undefined
            ? {
                data: d.data,
                text: d.text,
                blur,
            }
            : { data: d.data, text: d.text });
    });
}
export function getQueryResultValues({ values = [], metadata = [] }) {
    var _a, _b, _c, _d;
    // fixing measures query result
    if (values[0] && !Array.isArray(values[0])) {
        values = [values];
    }
    for (let i = 0; i < values.length; i++) {
        const row = values[i];
        for (let c = 0; c < row.length; c++) {
            if (metadata[c].format && ((_b = (_a = metadata[c]) === null || _a === void 0 ? void 0 : _a.format) === null || _b === void 0 ? void 0 : _b.number)) {
                row[c].text = numeral(row[c].data).format((_d = (_c = metadata[c]) === null || _c === void 0 ? void 0 : _c.format) === null || _d === void 0 ? void 0 : _d.number);
            }
        }
    }
    return values;
}
//# sourceMappingURL=get-data-from-query-result.js.map